/* eslint-disable no-console */
import { newReconServiceAPI, reconServiceAPI } from "./APIutils";
import { BASE_URL, NEW_BASE_URL } from "../Constant";

export function fetchDistanceReportData({
  pageNo,
  pageSize = 10,
  dateFilter = {},
  cityFilter = [],
  operatorFilter = [],
}) {
  const url = `${NEW_BASE_URL}/v1/reconReports/distance`;
  return newReconServiceAPI(url, {
    cityIdArr: cityFilter,
    operatorIdArr: operatorFilter,
    fromDate: dateFilter.fromDate,
    toDate: dateFilter.toDate,
    pageNo,
    pageSize,
  });
}

export function fetchMobileTicketData({
  pageNo,
  pageSize = 10,
  sortBy = "",
  dateFilter = {},
  cityFilter = [],
  operatorFilter = [],
}) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "getMobileTicketData",
    paramValue: {
      query: {
        id: "getMobileTicketData",
        sort: sortBy,
        addOnFilter: { cityIdArr: cityFilter, operatorIdArr: operatorFilter, date: dateFilter },
      },
      pageNo,
      pageSize,
      model: "BusDayWise",
    },
  });
}

export function fetchDistanceReportDetails({
  pageNo,
  pageSize = 10,
  dateFilter = {},
  cityId = "",
  operatorFilter = [],
  agencyId = "",
}) {
  const url = `${NEW_BASE_URL}/v1/reconReports/distanceDetails`;
  return newReconServiceAPI(url, {
    cityId,
    operatorIdArr: operatorFilter,
    fromDate: dateFilter?.fromDate,
    toDate: dateFilter?.toDate,
    agencyId,
    pageNo,
    pageSize,
  });
}

export function fetchMobitTicketsDetails({
  pageNo,
  pageSize = 10,
  sortBy = "",
  dateFilter = {},
  cityId = "",
  operatorFilter = [],
}) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "getMobileTicketDetails",
    paramValue: {
      query: {
        id: "getMobileTicketDetails",
        sort: sortBy,
        addOnFilter: { cityId, operatorIdArr: operatorFilter, date: dateFilter },
      },
      pageNo,
      pageSize,
      model: "BusDayWise",
    },
  });
}

export function fetchMobileSettlementDetails({
  pageNo,
  pageSize = 10,
  sortBy = "",
  dateFilter = {},
  cityId,
  operatorFilter = [],
}) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "getResidualSettlementDetails",
    paramValue: {
      query: {
        id: "getResidualSettlementDetails",
        sort: sortBy,
        addOnFilter: {
          cityId,
          operatorIdArr: operatorFilter,
          date: dateFilter,
          distributionType: "mobileTicket",
        },
      },
      pageNo,
      pageSize,
      model: "BusDayWise",
    },
  });
}

export function uploadExcelFile(data) {
  const url = `${NEW_BASE_URL}/v1/reconReports/uploadSettlementDistance`;
  return newReconServiceAPI(url, {
    ...data,
  });
}

export function runSettlement({
  pageNo,
  pageSize = 10,
  sortBy = "",
  dateFilter = {},
  cityId = "",
  operatorFilter = [],
  agencyId = "",
}) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "unsettledResidualSettlement",
    paramValue: {
      query: {
        id: "unsettledResidualSettlement",
        sort: sortBy,
        addOnFilter: {
          cityId, operatorIdArr: operatorFilter, date: dateFilter, agencyId,
        },
      },
      pageNo,
      pageSize,
      model: "BusDayWise",
    },
  }).then((res) => {
    console.log(res);
    return res;
  })
    .catch((error) => {
      throw error;
    });
}

export function sendFileKey({ key = "", fileName = "", ...other }) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "uploadSettlementDistance",
    paramValue: {
      query: {
        id: "uploadSettlementDistance",
      },
      data: {
        key,
        fileName,
        ...other,
      },
    },
  })
    .then((res) => {
      console.log(res);
      return res;
    })
    .catch((error) => {
      throw error;
    });
}

export function fetchPassData({
  pageNo,
  pageSize = 10,
  sortBy = "",
  dateFilter = {},
  cityFilter = [],
  operatorFilter = [],
}) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "getPassData",
    paramValue: {
      query: {
        id: "getPassData",
        sort: sortBy,
        addOnFilter: { cityIdArr: cityFilter, operatorIdArr: operatorFilter, date: dateFilter },
      },
      pageNo,
      pageSize,
      model: "BusDayWise",
    },
  });
}

export function fetchPassDetails({
  pageNo,
  pageSize = 10,
  sortBy = "",
  dateFilter = {},
  cityId = "",
  operatorFilter = [],
}) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "getPassDetails",
    paramValue: {
      query: {
        id: "getPassDetails",
        sort: sortBy,
        addOnFilter: { cityId, operatorIdArr: operatorFilter, date: dateFilter },
      },
      pageNo,
      pageSize,
      model: "BusDayWise",
    },
  });
}

export function fetchPassSettlementDetails({
  pageNo,
  pageSize = 10,
  sortBy = "",
  dateFilter = {},
  cityId,
  operatorFilter = [],
}) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "getResidualSettlementDetails",
    paramValue: {
      query: {
        id: "getResidualSettlementDetails",
        sort: sortBy,
        addOnFilter: {
          cityId,
          operatorIdArr: operatorFilter,
          date: dateFilter,
          distributionType: "passRevenue",
        },
      },
      pageNo,
      pageSize,
      model: "BusDayWise",
    },
  });
}

export function generateDistributionService({
  dateFilter = {},
}) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "calculatePassRevenueDistribution",
    paramValue: {
      query: {
        id: "calculatePassRevenueDistribution",
        addOnFilter: { date: dateFilter },
      },
      model: "BusDayWise",
    },
  }).then((res) => {
    console.log(res);
    return res;
  })
    .catch((error) => {
      throw error;
    });
}

// Api call to get bulk settlement distance upload status
export const getSettlementDistanceStatusService = async (filter = {}) => {
  const url = `${NEW_BASE_URL}/v1/reconReports/settlementDistanceUploadStatus`;
  const res = await newReconServiceAPI(url, {
    addOnFilter: filter,
  });
  return res;
};

export function fetchPassRevenueDistribution({
  pageNo,
  pageSize = 10,
  sortBy = "",
  dateFilter = {},
  cityId = "",
  operatorFilter = [],
}) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "getProductWisePassRevenueDistribution",
    paramValue: {
      query: {
        id: "getProductWisePassRevenueDistribution",
        sort: sortBy,
        addOnFilter: { cityId, operatorIdArr: operatorFilter, date: dateFilter },
      },
      pageNo,
      pageSize,
      model: "BusDayWise",
    },
  });
}

export function fetchOperatorWiseReport({
  pageNo,
  pageSize = 10,
  sortBy = "",
  dateFilter = {},
  cityFilter = [],
  operatorFilter = [],
}) {
  const url = `${BASE_URL}`;
  return reconServiceAPI(url, {
    id: "getOperatorWiseReportData",
    paramValue: {
      query: {
        id: "getOperatorWiseReportData",
        sort: sortBy,
        addOnFilter: { cityIdArr: cityFilter, operatorIdArr: operatorFilter, date: dateFilter },
      },
      pageNo,
      pageSize,
      model: "BusDayWise",
    },
  });
}
